import * as React from 'react';

const getSchema = (title) => {
  return {
    READING: {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'TRANG CHỦ',
          item: 'https://dolacademy.vn/',
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'IELTS ONLINE TEST',
          item: 'https://dolacademy.vn/luyen-thi-ielts/free-ielts-online-test',
        },
        {
          '@type': 'ListItem',
          position: 3,
          name: 'IELTS READING PRACTICE TESTS',
          item: 'https://dolacademy.vn/luyen-thi-ielts/ielts-reading-practice',
        },
        {
          '@type': 'ListItem',
          position: 4,
          name: title,
        },
      ],
    },
    LISTENING: {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'TRANG CHỦ',
          item: 'https://dolacademy.vn/',
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'IELTS ONLINE TEST',
          item: 'https://dolacademy.vn/luyen-thi-ielts/free-ielts-online-test',
        },
        {
          '@type': 'ListItem',
          position: 3,
          name: 'IELTS LISTENING PRACTICE TESTS',
          item: 'https://dolacademy.vn/luyen-thi-ielts/ielts-listening-practice',
        },
        {
          '@type': 'ListItem',
          position: 4,
          name: title,
        },
      ],
    },
    FULL: {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'TRANG CHỦ',
          item: 'https://dolacademy.vn/',
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'IELTS ONLINE TEST',
          item: 'https://dolacademy.vn/luyen-thi-ielts/free-ielts-online-test',
        },
        {
          '@type': 'ListItem',
          position: 3,
          name: title,
        },
      ],
    },
  };
};

interface LandingJsonLdSchemaProps {
  testType: 'FULL_TEST' | 'PRACTICE_TEST';
  skill: 'LISTENING' | 'READING';
  title: string;
}

export const useLandingJsonLdSchemaForTuHocIelts = ({
  testType,
  skill,
  title,
}: LandingJsonLdSchemaProps) => {
  let schema = null;
  switch (testType) {
    case 'PRACTICE_TEST': {
      if (skill === 'LISTENING') {
        schema = getSchema(title)?.LISTENING;
        break;
      }
      if (skill === 'READING') {
        schema = getSchema(title)?.READING;
        break;
      }
      break;
    }
    case 'FULL_TEST': {
      schema = getSchema(title)?.FULL;
    }
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};
